module.exports = __webpack_public_path__ + "static/media/Rectangle1.2092ec21.png";